"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.REGEX_FORM_FIELDS = void 0;
/**
 * This is an attempt to unify and explain the usage of all regex in form fields.
 * The formd fields (attributes) of a Payment Method will live in payment-methods-vivillon
 * and will be rendered by webapp-milotic.
 * Any new regex for a new form filed should live here to make sure it doesn't exist already.
 * Better ways to check this will be implemented in the future.
 * @3ddmoo
 */
exports.REGEX_FORM_FIELDS = {
    /** Required field */
    REGEX_REQUIRED: '^.+$',
    /** Email Address */
    // Regex extracted from this issue https://github.com/jquense/yup/issues/507
    REGEX_EMAIL: '^(([^<>()\\[\\]\\\\.,;:\\s@"]+(\\.[^<>()\\[\\]\\\\.,;:\\s@"]+)*)|(".+"))@((\\[[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}\\.[0-9]{1,3}])|(([a-zA-Z\\-0-9]+\\.)+[a-zA-Z]{2,}))$',
    /** Name (Extended ASCII, hyphen, apostrophe, multiple words support) */
    REGEX_NAME: /^[A-Za-z\u00C0-\u00FF][A-Za-z\u00C0-\u00FF'-]+([ A-Za-z\u00C0-\u00FF]+[A-Za-z\u00C0-\u00FF'-]+)*$/,
    /** Phone Number */
    REGEX_PHONE_NUMBER: '^[\\+|\\d][0-9]+$',
    /** Phone Number Withoutcode */
    REGEX_PHONE_NUMBER_WITHOUT_CODE: '^\\d{6,15}$',
    // This allows: any word char, any whitespace char, commas, dots, (), -.
    REGEX_POSTAL_ADDRESS: /^(\w|\s|,|\.|\(|\)|-)+$/s,
    /** Website */
    REGEX_WEBSITE: '^[^\\s]+$',
    /** USA Bank Account Number */
    REGEX_BANK_ACCOUNT_USA: '^\\d{1,17}$',
    REGEX_BANK_ACCOUNT_DIRECT_USA: '^\\d{10,12}$',
    REGEX_BANK_ACCOUNT_DIRECT_SELL_USA: '^\\d{6,17}$',
    /** India Bank Account Number */
    REGEX_BANK_ACCOUNT_INDIA: '^\\d{10,20}$',
    /** Bangladesh Bank Account Number */
    REGEX_BANK_ACCOUNT_BANGLADESH: '^[0-9]{8,16}$',
    /** Bolivia Bank Account Number */
    REGEX_BANK_ACCOUNT_BOLIVIA: '^[0-9]{1,15}$',
    /** Ecuador Bank Account Number */
    REGEX_BANK_ACCOUNT_ECUADOR: '^[A-Za-z0-9]{1,30}$',
    /** Morocco Bank Account Number */
    REGEX_BANK_ACCOUNT_MOROCCO: '^[0-9]{24}$',
    /** Paraguay Bank Account Number */
    REGEX_BANK_ACCOUNT_PARAGUAY: '^[0-9]{16}$',
    /** Uruguay Bank Account Number */
    REGEX_BANK_ACCOUNT_URUGUAY: '^[A-Za-z0-9]{1,14}$',
    /**
     * Venezuela Bank Account Number
     * Peru Bank Account Number
     */
    REGEX_BANK_ACCOUNT: '^[0-9]{20}$',
    /** Cambodia Bank Account Number */
    REGEX_BANK_ACCOUNT_CAMBODIA: '^[0-9]{9,34}$',
    /** Panama Bank Account Number */
    REGEX_BANK_ACCOUNT_PANAMA: '^[0-9]{8,17}$',
    /** Chile Bank Account Number */
    REGEX_BANK_ACCOUNT_CHILE: '^[A-Za-z0-9]{1,45}$',
    /** Colombia Bank Account Number */
    REGEX_BANK_ACCOUNT_COLOMBIA: '^[A-Za-z0-9]{9,13}$',
    /** UK Bank Account Number */
    REGEX_BANK_ACCOUNT_UK: '^[0-9]{1,8}$',
    /** Argentina - CBU (Clave Bancaria Uniforme) */
    REGEX_CBU: '^[0-9]{22}$',
    /** Mexico - CLABE (Clave Bancaria Estandarizada) */
    REGEX_CLABE: '^[0-9]{18}$',
    /** Mexico - CLABE or card number */
    REGEX_CLABE_OR_CARD: '^[0-9]{16,18}$',
    /** Mexico - CLABE or phone number */
    REGEX_CLABE_OR_PHONE: '^[0-9]{8,18}$',
    /** Mexico - CURP (Clave Única de Registro de Población) */
    REGEX_CURP: '^[A-Z][AEIOUX][A-Z]{2}\\d{6}[M,H][A-Z]{5}[0-9A-Z][0-9]$',
    /** Mexico - RFC (Registro Federal de Contribuyentes) */
    REGEX_RFC: '^[A-ZÑ&]{3,4}\\d{6}[A-V1-9][A-Z1-9][0-9A]$',
    /** India Bank Branch */
    REGEX_BRANCH_INDIA: '^[A-Za-z0-9]+$',
    /** Bangladesh Bank Branch */
    REGEX_BRANCH_BANGLADESH: '^[0-9]{9}$',
    /** Uruguay Banck Branch */
    REGEX_BRANCH_URUGUAY: '^[0-9]{1,45}$',
    /** India - IFSC (Indian Financial System Code) */
    REGEX_IFSC: '^[A-Za-z]{4}0[A-Za-z0-9]{6}$',
    /** Chile - RUT (Registro Único Tributario) */
    REGEX_RUT: '^[0-9]{2}\\.[0-9]{3}\\.[0-9]{3}-[A-Za-z0-9]{1}$',
    REGEX_RUT_DLOCAL: '^[A-Za-z0-9]{8,9}$',
    /** US Bank Routing Number */
    REGEX_ROUTING_US: '^[0-9]{9}$',
    /** Ripple Tag */
    REGEX_RIPPLE_TAG: '^[0-9]{5,10}$',
    /** Nigeria - NUBAN (Nigeria Uniform Bank Account Number) */
    REGEX_NUBAN: '^([0-9]{16}|[0-9]{10})$',
    REGEX_NUBAN_NEW: '^[0-9]{16}$',
    /** Colombia CC/NIT */
    REGEX_CC_OR_NIT: '^[0-9]{10}$',
    /**
     * Argentina - CUIT( Clave Única de Identificación Tributaria)
     * Brazil - CPF (Cadastro de Pessoas Físicas)
     */
    REGEX_TAX_ID_LATAM: '^[0-9]{11}$',
    REGEX_TAX_ID_BRAZIL: '^[0-9]{11,14}$',
    /** Ecuador Tax ID */
    REGEX_TAX_ID_ECUADOR: '^[0-9]{13}$',
    /** Ecuador ID */
    REGEX_ID_ECUADOR: '^[0-9]{10,15}$',
    /** Peru ID */
    REGEX_ID_PERU: '^[0-9]{8,11}$',
    /** Uruguay ID */
    REGEX_ID_URUGUAY: '^[0-9]{8,12}$',
    /** Venezuela ID */
    REGEX_ID_VENEZUELA: '^[V|v|E|e|J|j|P|p|G|g][0-9]{7,9}$',
    /**
     * Binance Coin Address
     * Dai Address
     * Chainlink Address
     * Augur Address
     * Icon Address
     * Enzyme Address
     * OMG Network Address
     * BAT Address
     * Gnosis Address
     */
    REGEX_ADDRESS_CRYPTO: '^[A-Za-z0-9]{42}$',
    /** Eos Address */
    REGEX_ADDRESS_CRYPTO_12: '^[A-Za-z0-9]{12}$',
    /** Waves Address */
    REGEX_ADDRESS_CRYPTO_35: '^[A-Za-z0-9]{35}$',
    /** Tezos Address */
    REGEX_ADDRESS_CRYPTO_36: '^[A-Za-z0-9]{36}$',
    /** Bitcoin Address */
    REGEX_ADDRESS_BITCOIN: '^(bc1|[13])[a-km-zA-HJ-NP-Z1-9]{25,34}$',
    /** Ethereum Address */
    REGEX_ADDRESS_ETHEREUM: '^0x[a-fA-F0-9]{40}$',
    /**
     * Filecoin Address
     * Lisk Address
     */
    REGEX_ADDRESS_CRYPTO_41: '^[A-Za-z0-9]{41}$',
    /** PAX Gold Address */
    REGEX_ADDRESS_CRYPTO_42: '^[A-Za-z0-9]{42}$',
    /** Cosmos Address */
    REGEX_ADDRESS_CRYPTO_45: '^[A-Za-z0-9]{45}$',
    /** Polkadot Address */
    REGEX_ADDRESS_CRYPTO_48: '^[A-Za-z0-9]{48}$',
    /** Algorand Address */
    REGEX_ADDRESS_CRYPTO_58: '^[A-Za-z0-9]{58}$',
    /** Siacoin Address */
    REGEX_ADDRESS_CRYPTO_76: '^[A-Za-z0-9]{76}$',
    /** Cardano Address */
    REGEX_ADDRESS_CRYPTO_CARDANO: '(^[1-9A-HJ-NP-Za-km-z]{64,128}$)|(^addr1[a-z0-9]{53,128}$)',
    /** Litecoin Address */
    REGEX_ADDRESS_LITECOIN: '^[A-Za-z0-9]{26,71}$',
    /** Ripple Address */
    REGEX_ADDRESS_RIPPLE: '^[A-Za-z0-9]{25,34}$',
    /** Uganda Binusu[Crypto Exchange] - Crypto Address */
    REGEX_ADDRESS_BINUSU: '[A-Za-z0-9]{26,42}$',
    /** Brazil Bank Agency */
    REGEX_AGENCY_BRAZIL: '^[A-Za-z0-9]{3,8}$',
    /**
     * Tether Address
     * Tron Address
     * Qtum Address
     */
    REGEX_ADDRESS_TETHER: '^[A-Za-z0-9]{34}$',
    /** Zcash Address */
    REGEX_ADDRESS_ZCASH: '^[A-Za-z0-9]{35,96}$',
    /** Stellar Lumnes Address */
    REGEX_ADDRESS_STELLAR: '^[A-Za-z0-9]{56}$',
    /** Monero Address */
    REGEX_ADDRESS_MONERO: '^[A-Za-z0-9]{95,106}$',
    /** Bitcoin Cash Address */
    REGEX_ADDRESS_BITCOINCASH: '^(bitcoincash:){0,1}[A-Za-z0-9]{26,42}$',
    /** Ronin Address */
    REGEX_RONIN_WALLET: '^ronin:[A-Za-z0-9]{40,256}$',
    /** sUSDC Memo */
    REGEX_SUSDC_MEMO: '^[A-Za-z0-9]{1,32}$',
    /** Perfect Money Account Number */
    REGEX_PERFECT_MONEY_ACCOUNT: '^[A-Za-z][0-9]{7,8}$',
    /** Last 2 to 4 characters of account registered with Plaid */
    REGEX_PLAID_ACCOUNT_MASK: '^[A-Za-z0-9]{2,4}$',
    /** UK Bank sort code */
    REGEX_SORT_CODE: '^[0-9]{1,6}$',
    /** IBAN */
    REGEX_IBAN: '^[A-Za-z0-9]{1,22}$',
    REGEX_IBAN_COSTA_RICA: '^[A-Za-z0-9]{22}$',
    REGEX_IBAN_EUROPEAN_UNION: '^[A-Za-z0-9]{1,34}$',
    REGEX_IBAN_TURKEY: '^[A-Za-z0-9]{26}$',
    /** UPI Address */
    REGEX_UPI_ADDRESS: '^[0-9]{10}@ybl$',
    /** Colombian National Identification Number */
    REGEX_NATIONAL_IDENTIFICATION_NUMBER_COLOMBIA: '^[A-Za-z0-9-]{3,20}$',
    /** Costa Rica National Identification Number */
    REGEX_NATIONAL_IDENTIFICATION_NUMBER_COSTA_RICA: '^[0-9]{9,22}$',
    /** Paraguay National Identification Number */
    REGEX_NATIONAL_IDENTIFICATION_NUMBER_PARAGUAY: '^[0-9]{7,8}$',
    /** Panama National Identification Number */
    REGEX_NATIONAL_IDENTIFICATION_NUMBER_PANAMA: '^[A-Za-z0-9]{10,12}$',
    /** Business name **/
    REGEX_BUSINESS_NAME: /^(?!\s)(?!.*\s$)(?=.*[a-zA-Z0-9])[a-zA-Z0-9 '~?!]{2,}$/s,
    /** Lemon Cash $lemontag **/
    REGEX_LEMON_TAG: '^\\$\\S+$',
    /** Full IBAN **/
    REGEX_FULL_IBAN: '^([A-Z]{2}[ \\-]?[0-9]{2})(?=(?:[ \\-]?[A-Z0-9]){9,30}$)((?:[ \\-]?[A-Z0-9]{3,5}){2,7})([ \\-]?[A-Z0-9]{1,3})?$',
    /** Swift/bin code for wire transfers */
    REGEX_SWIFT_BIN_CODE: '^[A-Z]{6}[A-Z0-9]{2}([A-Z0-9]{3})?$',
    /** PAYER WALLET  */
    REGEX_PAYEER_WALLET_NUMBER: '^P([a-zA-Z0-9]{0,11})$',
    REGEX_ADVCASH_ACCOUNT_NUMBER: '^[a-zA-Z0-9]{1,42}$',
    /** BELO $beloTag **/
    REGEX_BELO_TAG: '^\\$\\S+$',
    /** BIC Code  EGYPT **/
    REGEX_BIC_CODE: '^[A-Z0-9]{8,11}$',
    /** Account Number Kenya **/
    REGEX_ACCOUNT_NUMBER_KENYA: '^[A-Za-z0-9]{8,20}$',
    /** CashApp **/
    REGEX_CASHAPP: '^\\$(?=.*[a-zA-Z].*)([a-zA-Z0-9]{1,20})$',
    /** Venmo **/
    REGEX_VENMO_USERNAME: '^[a-zA-Z0-9-_]{5,30}$',
};
